<template>
<div class="popup" v-if="uploadToShow" v-cloak id="uploadToTree">
    <div id="pleaseSelect" class="content">
		
        <div class="title">
            <span>{{$t('language.popup.cloudTransferPopup.pleaSelect')}}</span>
            <div class="icon white-close dialog-close" @click="closeSelect()"></div>
        </div>
        <div class="task-content" v-loading="loading" ref="aimTree">
             <el-scrollbar style="height:100%;">
            <div v-if="!model.length&&!loading" class="nondrive-des" @click="toAddCloudPage()">
                {{$t('language.popup.cloudTransferPopup.addValidCloud')}}
            </div>
            <div class="tree-nodes" id="treeNodes">
                <ul :key="index" v-for="(item,index) in model">
                    <tree  ref="tree" :model="item" :index="index" :treeShow=true :transferAimFlag=createFolder></tree>
                </ul>
            </div>
            </el-scrollbar>
        </div>
        <div class="task-footer">
            <button class="task-button" @click="cloudSubmit()">{{$t('language.common.ok')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import tree from "@/components/common/trees/tree";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            uploadToShow: false,
            model: [],
            createFolder: 'remoteTask',
            loading: true,
        };
    },
    mounted() {
        this.init()
    },
	watch:{
		uploadToShow(newValue,oldValue){
			if(newValue){
				this.init();
			}
		}
	},
    methods: {
		init(){
			this.$store.commit('setClickItem', null);
			this.$store.state.arr = [];
			let that = this;
			let models = this.$store.getters.getUsersDrives.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
			if (!models.length&&that.$route.name == 'remoteTask') {
			    this.model = this.Utils.getAllCloudsList(function (res) {
			        if (res.status == 200) {
                        //不需要邮箱
                        that.model = that.model.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
                        that.loading = false;
			        }
			    });
			} else {
                this.model = models;
			    this.loading = false;
			}
			$.each(this.model, function (index, item) {
				item.open = false;
			    if (item.children && item.children.length) {
			        delete item.children;
			    }
			});
		},
        getFilePath(json, nodes) {
            node = null;
            if (nodes == null) return "";
            let fileName = nodes.name;
            var res = this.getNode(json, nodes.id);
            var pNode = res.parentNode;
            if (pNode != null) {
                if (pNode.name != null && pNode != undefined) {
                    fileName = this.getFilePath(json, pNode) + "/" + fileName;
                }
            }
            return fileName;
        },
        cloudSubmit() {
            let that = this;
            let node = this.$store.state.clickItem;
            let type = node.driveType;
            let pathArray = taskTransferUtils.findFilePathArray(this.model, node, []);
            let path = pathArray[0];
            for (let i = 1; i < pathArray.length; i++) {
                path = path + '\\' + pathArray[i];
            }
            node.driveType = type;
            node.cloudCatalog = path;
            this.$parent.$refs.linkTaskDialog.toDrivesInfo = node;
            this.$parent.$refs.linkTaskDialog.cloudType = type;
            this.$parent.$refs.linkTaskDialog.cloudCatalog = path;
            this.uploadToShow = false;
            this.$parent.$refs.linkTaskDialog.linkTaskShow = true;
        },
		closeSelect(){
			this.uploadToShow = false;
			this.$parent.$refs.linkTaskDialog.linkTaskShow = true;
		},
        toAddCloudPage() {
            let dom;
            let that = this;
            $.each(that.$parent.$parent.$children, function (i, item) {
                if (item.menuOptions) {
                    dom = that.$parent.$parent.$children[i];
                    dom.menuOptionSelect(10);
                    return;
                }
            });
        },
    },
    components: {
        tree
    }
};
</script>

<style>
.el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
}
#uploadToTree #pleaseSelect .el-loading-spinner .circular {
    height: 25px !important;
    /*no*/
    width: 25px !important;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/remote_task_popups/upload_to_tree_popup.vue